import { useDispatch, useSelector } from "react-redux";
import CommanForm from "../../../../components/FormController/Commanform";
import CommanPhoneNumber from "../../../../components/Ui/PhoneNumber";
import AddStaffMembervalidation from "../../../../yup/Staff/AddStaffMember";
import { useEffect, useState } from "react";
import { StaffMemberCategoryServiceGetAction, StaffMemberDetailAction, StaffMemberUpdateAction } from "../../../../redux/Action/StaffMemberAction";
import { useLocation, useNavigate } from "react-router-dom";
import { ArraySortByIndex, decodeID, getLastURL, sidebarOpen, validImageTypes, validateImage } from "../../../../utils/Helper";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import Button from "../../../../components/Ui/Button";
import Errormessages from "../../../../components/ErrorMessage/Errormessages";
import NewStaff from "../../../../components/Model/NewStaff";
import { handleOwnerImageChange } from "../../../Profile/CompanyProfile/Image";
import Spinner from "../../../../components/Spinner";
import { CategoryAction } from "../../../../redux/Action/ProfileAction";
import { FormattedMessage } from "react-intl";
import { useIntl } from 'react-intl';

const StaffMemberUpdate = () => {
    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const staff_member_detail: any = useSelector((state: any) => state.StaffMemberDetailState)
    const staff_member_update_data: any = useSelector((state: any) => state.StaffMemberUpdateState)
    const [profileImg, setProfileImg] = useState("")
    const [category, setCateory] = useState<any[]>([]);
    const [serviceData, setServiceData]: any = useState([])
    const [selectedServices, setSelectedServices]: any = useState([])
    const [serviceId, setServiceId]: any = useState([])
    const [categoriesLength, setCategoriesLength] = useState(0)
    let arr: any = []


    const [newStaffComponents, setNewStaffComponents]: any = useState([]);
    const [staffImage, setOwnerImage] = useState(null)


    const handleStaffImage = (e: any) => { handleOwnerImageChange({ e, setValue, setOwnerImage, validateImage, validImageTypes }) };



    useEffect(() => {
        // if(categoriesLength)
        setNewStaffComponents(Array(categoriesLength).fill(0));
    }, [categoriesLength])



    const handleAdd = () => {
        setNewStaffComponents([...newStaffComponents, newStaffComponents.length]);
    };


    const location = useLocation();
    const viewId = getLastURL(location);
    const params = { detail_id: decodeID(viewId) };

    const { register, errors, handleSubmit, setValue, trigger, watch, getValues, setError, reset } = CommanForm({ validationSchema: AddStaffMembervalidation });






    const onSubmit = (payload: any) => {
        let arr: any = []
        // se?.map((item: any) => {

        //     arr.push(item?.value)
        // })

        const catIds = category.map((item: any) => item?.catId);
        const profile_img = watch('profile_img')?.[0];

        const data = {
            // category_id: JSON.stringify(catIds),
            // service_id: selectedServices ? JSON.stringify(ArraySortByIndex(selectedServices)) : [],
            service_id: selectedServices ? JSON.stringify(selectedServices) : [],
            // service_id: arr ? JSON.stringify(arr) : [],
            ...(profile_img ? { profile_pic: profile_img } : {}),
            owner_name: payload?.name,
            email: payload?.email,
            phone_country_code: `+${payload?.phone_country_code?.replace(/^\++/, '')}`,
            // phone_country_code: payload?.phone_country_code.startsWith("+")
            // ? payload.phone_country_code
            // : "+" + payload?.phone_country_code,

            phone_number: payload?.phone_number,
            location: payload?.address,
            edit_id: params?.detail_id,
        }

        dispatch(StaffMemberUpdateAction(data))
    }


    useEffect(() => {
        dispatch(StaffMemberDetailAction(params))
    }, [])



    const breadcrumbItems = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'Staff_Member_List', link: '/staff-member' },
        { title: 'edit_staff_member' }
    ];


    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number")
    }

    let service: any = []

    useEffect(() => {
        if (staff_member_detail?.status) {
            setValue("name", staff_member_detail?.data?.data?.detail?.owner_name)
            setValue("email", staff_member_detail?.data?.data?.detail?.email)
            setValue("address", staff_member_detail?.data?.data?.detail?.location)
            setValue('phone_country_code', staff_member_detail?.data?.data?.detail?.phone_country_code);
            // setValue('phone_countrydashboard_code', staff_member_detail?.data?.data?.detail?.phone_country_code);
            setValue('phone_number', staff_member_detail?.data?.data?.detail?.phone_number);
            // setValue("profile_img", staff_member_detail?.data?.data?.detail?.profile_pic)

            setProfileImg(staff_member_detail?.data?.data?.detail?.profile_pic)

            staff_member_detail?.data?.data?.detail?.allCategoryDetails?.map((item: any, index: any) => {
                dispatch(StaffMemberCategoryServiceGetAction({ cat_id: item?.id, index }));
                arr.push({ index: index, catId: item?.id })
            })


            staff_member_detail?.data?.data?.detail?.allServiceDetails?.map((item: any, index: any) => {
                service.push({ index: index, value: item?.id });
            });


            if (staff_member_detail?.data?.data?.detail?.allServiceDetails?.length > 0) {
                staff_member_detail?.data?.data?.detail?.allServiceDetails?.map((selSer: any, index: any) => {

                    setSelectedServices((prevData: any) => {
                        return [...prevData, selSer?.id]

                    })

                })
                // setSelectedServices()
                //     const service = staff_member_detail.data.data.detail.allServiceDetails.map((item: any, index: any) => ({
                //         index: index,
                //         id: item.id,
                //         name: item.name,
                //     }));
                //     setServiceData(service);
            }

            setCateory(arr);
            setCategoriesLength(arr?.length)
            // setServiceData(service)
        }

    }, [staff_member_detail?.status])




    const navigate = useNavigate()
    useEffect(() => {
        if (staff_member_update_data?.status) {
            navigate("/staff-member")
        }
    }, [staff_member_update_data])

    useEffect(() => {
        return () => {
            dispatch(StaffMemberDetailAction("RESET"))
            dispatch(StaffMemberUpdateAction("RESET"))

        }
    }, [])

    const category_data = useSelector((state: any) => state.CategoryState);


    useEffect(() => {
        dispatch(CategoryAction({}));
    }, [dispatch]);

    const handleCategory = (e: any, index: number) => {
        const catId = e.target.value;


        setCateory((prevArr) => {
            if (catId) {
                const newArr = [...prevArr];
                newArr[index] = { index, catId: Number(catId) };

                return newArr;
            } else {
                return prevArr.filter((item) => item.index !== index);
            }
        });

        dispatch(StaffMemberCategoryServiceGetAction({ cat_id: catId, index }));

        // setCateory((prevArr: any) => {
        //     const existingEntry = prevArr.find((item: any) => item.index === index);
        //     if (existingEntry) {
        //         if (existingEntry.catId === catId || catId === "") {
        //             return prevArr.filter((item: any) => item.index !== index);
        //         }
        //         return prevArr.map((item: any) => item.index === index ? { index, catId } : item);
        //     }
        //     else {
        //         if (catId !== "") {
        //             return [...prevArr, { index, catId }];
        //         }
        //     }

        //     return prevArr;
        // });
        // dispatch(StaffMemberCategoryServiceGetAction({ cat_id: catId, index }));
    };

    const [selectedServicesId, setSelectedServicesId] = useState<any[]>([]);


    const handleSelectServices = (e: any, index: any) => {
        // const value = e.target.value;
        // const arr = [...setServiceData];        
        // arr[index] = { index, value };
        // setSelectedServicesId(arr);

        const value = e.target.value;
        setSelectedServices((prevServiceData: any) => {
            const newData = [...prevServiceData];
            if (index !== undefined) {
                newData[index] = Number(value);
            }
            return newData;
        });

    };




    useEffect(() => {
        return () => {
            dispatch(StaffMemberCategoryServiceGetAction("RESET"))
        }
    }, [])
    const service_data = useSelector((state: any) => state.StaffMemberCategoryServiceState);
    useEffect(() => {
        if (service_data?.data) {
            setServiceData((prevServiceData: any) => {
                const newData = [...prevServiceData];
                const index = service_data.data.custom_params.index;
                if (index !== undefined) {
                    newData[index] = service_data.data.data;
                }
                return newData;
            });
        }
    }, [service_data]);



    return (
        <>
            <div className='col-lg-9 serviceManagement'>
                {staff_member_detail?.loading ? <Spinner /> : ""}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button onClick={() => { sidebarOpen() }} type='button' className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> <FormattedMessage id="edit_staff_member" /></h2>
                        <Breadcrumb items={breadcrumbItems} />
                    </div>
                    <div className='dashboarcard'>
                        <div className="row">
                            <div className="col-lg-8">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className='stafPhoto text-center mb-3' >
                                        <figure>
                                            {
                                                staffImage != undefined && staffImage || staff_member_detail?.data?.data?.detail?.profile_pic ? <img src={staffImage ? URL.createObjectURL(staffImage) : staff_member_detail?.data?.data?.detail?.profile_pic} /> :
                                                    <span className="icon-upload"></span>

                                            }
                                        </figure>
                                        <button type='button' className='btn btn-sm-outline'><span className="icon-edit">
                                        </span> <FormattedMessage id="add_photo" />
                                            <input type='file' {...register("profile_img")} onChange={(e: any) => {
                                                handleStaffImage(e)
                                                trigger("profile_img")
                                            }} />
                                        </button>
                                        <Errormessages errors={errors} name="profile_img" />
                                        {/* <p className="text-danger">{profileImageError}</p> */}

                                    </div>
                                    <div className='row gy-3 placeholder-wave' >
                                        <div className='col-12'>
                                            <div className='normalINput'>
                                                <label className="form-label"><FormattedMessage id="staff_member_name_data" /></label>
                                                <input type="text" className="form-control" placeholder={intl.formatMessage({ id: 'enter_name' })}
                                                    {...register("name")}
                                                    maxLength={15}
                                                    onInput={(e: any) => {
                                                        const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                        setValue("name", value);
                                                    }}

                                                />
                                            </div>
                                            <Errormessages errors={errors} name="name" />
                                        </div>

                                        <div className='col-sm-6'>
                                            <div className='normalINput'>
                                                <label className="form-label"><FormattedMessage id="email_address" /></label>
                                                <input type="email" className="form-control" placeholder={intl.formatMessage({ id: 'enter_email_address' })}{...register("email")} disabled />
                                            </div>
                                            <Errormessages errors={errors} name="email" />

                                        </div>
                                        <div className='col-sm-6'>
                                            <div className='ReactnormalINput'>
                                                <label className="form-label"><FormattedMessage id="phone" /></label>
                                                <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={`${watch('phone_country_code')}${watch('phone_number')}`} />
                                            </div>

                                            <Errormessages errors={errors} name="phone_number" />

                                        </div>
                                        <div className='col-12'>
                                            <div className='normalINput'>
                                                <label className="form-label"><FormattedMessage id="address" /></label>
                                                <input type="text" className="form-control" placeholder={intl.formatMessage({ id: 'enter_address' })} {...register("address")}
                                                    onInput={(e: any) => {
                                                        const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                        setValue("address", value);
                                                    }}

                                                />
                                            </div>

                                            <Errormessages errors={errors} name="address" />

                                        </div>
                                        {
                                            newStaffComponents?.map((item: any, index: any) => {

                                                return (
                                                    <>
                                                        <div className="col-12" key={index}>
                                                            <div className="row">
                                                                <div className="col-sm-6">
                                                                    <div className="normalINput">
                                                                        <label className="form-label">{<FormattedMessage id="category" />}</label>
                                                                        <select
                                                                            className={`form-select cat_select_${index}`}
                                                                            onChange={(e) => handleCategory(e, index)}
                                                                        // value={category[index]?.catId}
                                                                        >

                                                                            {category[index]?.catId ? '' : <option value="">{<FormattedMessage id="select_category" />}</option>}
                                                                            {category_data?.data?.data?.categories?.map(
                                                                                (catItem: any) => (
                                                                                    <option
                                                                                        key={catItem?.category_detail?.id}
                                                                                        value={catItem?.category_detail?.id}
                                                                                        selected={Number(category[index]?.catId) === Number(catItem?.category_detail?.id)}
                                                                                    >
                                                                                        {catItem?.category_detail?.name}
                                                                                    </option>
                                                                                )
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-6">
                                                                    <div className="normalINput">
                                                                        <label className="form-label">{<FormattedMessage id="service" />}</label>
                                                                        {/* <button className='form-select' type='button'>
                                                                            <span className="spinner-border spinner-border-sm" style={{ borderWidth: '2px' }} role="status" aria-hidden="true"></span>
                                                                        </button> */}

                                                                        <select
                                                                            className={`form-select service_select_${index}`}
                                                                            {...register(`service${index}`)}
                                                                            onChange={(e) => handleSelectServices(e, index)}
                                                                        // value={serviceData[0] = 1}
                                                                        >
                                                                            <option value="">{<FormattedMessage id="select_service" />}</option>
                                                                            {serviceData[index]?.length > 0 &&
                                                                                serviceData[index]?.map(
                                                                                    (serviceItem: any) => {

                                                                                        return (
                                                                                            <option
                                                                                                key={serviceItem?.id}
                                                                                                value={serviceItem?.id}
                                                                                                selected={selectedServices[index] == serviceItem?.id}
                                                                                            >
                                                                                                {serviceItem?.name}
                                                                                            </option>
                                                                                        )
                                                                                    }
                                                                                )}
                                                                        </select>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div >
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <div className='text-center my-4'><span role='button' className='link' >+Add New</span></div> */}

                                    <div className='text-center my-4'><span role='button' className='link' onClick={handleAdd}>+{<FormattedMessage id="add_new" />}</span></div>

                                    <Button type="submit" className="btn btn-fill w-100" text={<FormattedMessage id="Save" /> as any} isLoading={staff_member_update_data?.loading} />
                                </form>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default StaffMemberUpdate;